(function () {
  'use strict';

  var lightbox = null;
  var lightboxImg = null;
  var lastTrigger = null;

  function ensureLightbox() {
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'oioi-story-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML =
      '<button type="button" class="oioi-story-lightbox__close btn-reset" aria-label="Close">&times;</button>'
      + '<img class="oioi-story-lightbox__img" alt="">';

    document.body.appendChild(lightbox);
    lightboxImg = lightbox.querySelector('.oioi-story-lightbox__img');

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.closest('.oioi-story-lightbox__close')) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });

    return lightbox;
  }

  function openLightbox(trigger) {
    var img = trigger.querySelector('img');
    if (!img) return;

    ensureLightbox();
    lastTrigger = trigger;
    lightboxImg.src = img.currentSrc || img.src;
    lightboxImg.alt = img.alt || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('oioi-story-lightbox-open');
    lightbox.querySelector('.oioi-story-lightbox__close').focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('oioi-story-lightbox-open');
    lightboxImg.removeAttribute('src');
    if (lastTrigger) lastTrigger.focus();
    lastTrigger = null;
  }

  function initStoryLightbox() {
    document.querySelectorAll('[data-story-lightbox]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openLightbox(trigger);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoryLightbox);
  } else {
    initStoryLightbox();
  }
})();
